import React from "react"
import { Box, Typography } from "@mui/material"
import { ImageSeeker } from "@ui-seeker/core"


export default function NoDataFound({ ...props }) {
	return <Box sx={{
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		'span': { width: 400, mt: -6, zIndex: -1, ...props.sx?.span }, ...props.sx
	}}>
		<ImageSeeker src="/resource/no-data.png" sx={{ opacity: 0.5 }}/>
		<Typography variant="body2" sx={{ fontSize: '1.25rem', marginTop: -6, color: 'text.disabled' }}>
			No data found with these parameters. Please, try again with other values!
		</Typography>
	</Box>
}